/** Non-empty trimmed value that parses as a finite `Date` (e.g. `datetime-local` value). */
export function isParseableLocalDateTime(trimmed: string): boolean {
  return trimmed.length > 0 && Number.isFinite(new Date(trimmed).getTime());
}

/**
 * Required text shown as empty after trim, or whitespace-only.
 * Empty-required message appears after blur or a submit attempt.
 */
export function requiredTrimmedTextFieldError(
  raw: string,
  trimmed: string,
  blurred: boolean,
  submitAttempted: boolean,
  requiredMessage: string,
  whitespaceOnlyMessage = 'Cannot be only whitespace.',
): string | null {
  if (raw.length > 0 && trimmed.length === 0) {
    return whitespaceOnlyMessage;
  }
  if (trimmed.length === 0 && (blurred || submitAttempted)) {
    return requiredMessage;
  }
  return null;
}

export function requiredLocalDateTimeFieldError(
  trimmed: string,
  blurred: boolean,
  submitAttempted: boolean,
  requiredMessage: string,
  invalidMessage: string,
): string | null {
  if (trimmed.length === 0 && (blurred || submitAttempted)) {
    return requiredMessage;
  }
  if (trimmed.length > 0 && !isParseableLocalDateTime(trimmed)) {
    return invalidMessage;
  }
  return null;
}
